// Generated by generateKotlinApi; do not edit.
package io.github.erkko68.kolt.physics.collision

import io.github.erkko68.kolt.*
import io.github.erkko68.kolt.capi.*
import io.github.erkko68.kolt.core.*
import io.github.erkko68.kolt.core.capi.*
import io.github.erkko68.kolt.geometry.*
import io.github.erkko68.kolt.geometry.capi.*
import io.github.erkko68.kolt.interop.*
import io.github.erkko68.kolt.math.*
import io.github.erkko68.kolt.objectstream.*
import io.github.erkko68.kolt.physics.*
import io.github.erkko68.kolt.physics.body.*
import io.github.erkko68.kolt.physics.body.capi.*
import io.github.erkko68.kolt.physics.capi.*
import io.github.erkko68.kolt.physics.character.*
import io.github.erkko68.kolt.physics.character.capi.*
import io.github.erkko68.kolt.physics.collision.broadphase.*
import io.github.erkko68.kolt.physics.collision.broadphase.capi.*
import io.github.erkko68.kolt.physics.collision.capi.*
import io.github.erkko68.kolt.physics.collision.shape.*
import io.github.erkko68.kolt.physics.collision.shape.capi.*
import io.github.erkko68.kolt.physics.constraints.*
import io.github.erkko68.kolt.physics.constraints.capi.*
import io.github.erkko68.kolt.physics.constraints.constraintpart.*
import io.github.erkko68.kolt.physics.ragdoll.*
import io.github.erkko68.kolt.physics.ragdoll.capi.*
import io.github.erkko68.kolt.physics.softbody.*
import io.github.erkko68.kolt.physics.softbody.capi.*
import io.github.erkko68.kolt.physics.vehicle.*
import io.github.erkko68.kolt.physics.vehicle.capi.*
import io.github.erkko68.kolt.skeleton.*
import io.github.erkko68.kolt.skeleton.capi.*

/**
 * Structure that holds a ray cast or other object cast hit
 *
 * C++ `JPH::BroadPhaseCastResult`.
 */
open class BroadPhaseCastResult internal constructor(internal val broadPhaseCastResultHandle: NativePointer, owned: Boolean = false) : NativeObject(owned), AutoCloseable {
    constructor() : this(JphBroadPhaseCastResult_create(), owned = true)

    override fun close() =
        closeOnce { JphBroadPhaseCastResult_destroy(broadPhaseCastResultHandle) }

    /** Function required by the CollisionCollector. A smaller fraction is considered to be a 'better hit'. For rays/cast shapes we can just use the collision fraction. */
    val earlyOutFraction: Float
        get() = JphBroadPhaseCastResult_GetEarlyOutFraction(broadPhaseCastResultHandle)

    /** Reset this result so it can be reused for a new cast. */
    fun reset() =
        JphBroadPhaseCastResult_Reset(broadPhaseCastResultHandle)

    /** Body that was hit */
    var bodyID: BodyID
        get() = BodyID(JphBroadPhaseCastResult_GetBodyID(broadPhaseCastResultHandle))
        set(value) = JphBroadPhaseCastResult_SetBodyID(broadPhaseCastResultHandle, value.value)

    /** Hit fraction of the ray/object \[0, 1\], HitPoint = Start + mFraction * (End - Start) */
    var fraction: Float
        get() = JphBroadPhaseCastResult_GetFraction(broadPhaseCastResultHandle)
        set(value) = JphBroadPhaseCastResult_SetFraction(broadPhaseCastResultHandle, value)

    /** This object as the [RayCastResult] it is, borrowed. Unchecked, as a C++ `static_cast`: it must be one. */
    fun asRayCastResult() = RayCastResult(JphRayCastResult_fromBroadPhaseCastResult(broadPhaseCastResultHandle))
}
